// import { useState } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';

import Jumbotron from './Jumbotron';
import Albums from './Albums';
import './style.css';
import Singles from './Singles';
// import { eps as e, lps as l} from './modules/Arrays';
import Body from './Body';
import Download from './Download';
import Search from './Search';

function Routes({ albums, singles }) {

//   const [eps, setEps] = useState(e);
//   const [lps, setLps] = useState(l);
  
  const jumbs = albums.length >= 3 ? [...albums].splice(0,3) : singles.length >= 3 ? [...singles].splice(0,3) : [];
  const history = useHistory();
  
  
  return (
      <Switch>

          <Route exact path="/">
            <Jumbotron jumbs={jumbs} />
            <Body albums={albums} singles={singles}  />
            <h2 className="const">STREAMING UNAVAILABLE ATM </h2>
          </Route>

          <Route path="/albums">
            <Albums albums={albums} />                       
          </Route>

          <Route path="/singles">
            {
              singles.length !== 0 ? <Singles singles={singles} /> :
              <div className="musicals">
                <button onClick={history.goBack}>Back</button>
                <h3>No Singles yet </h3>
              </div>
              
            }
          </Route>

          <Route path={"/eps"}>
              <div className="musicals">
                <button onClick={history.goBack}>Back</button>
                <h3>The EP feature is coming soon </h3>
              </div>
          </Route>

          <Route path={"/lps"}>
              <div className="musicals">
                <button onClick={history.goBack}>Back</button>
                <h3>The LP feature is coming soon </h3>
              </div>
          </Route>

          <Route path={"/play/:track"}>
              <div className="musicals">
                <button onClick={history.goBack}>Back</button>
                <p>Audio player - website/play/songname </p>
              </div>
          </Route>

          <Route path={"/download/:track"}>
              <Download />
          </Route>

          <Route path={"/search/:track"}>
              <Search />
          </Route>

          <Route path="*">
            <div className="musicals singles">
                <button onClick={history.goBack}>Back</button>
                <h3>404. Page Not Found</h3>
            </div>
          </Route>

      </Switch>
  );
}

export default Routes;